import React from 'react'
import { Context } from './Context'

/**
 *デフォルトページレイアウトで使うタイトルの初期化
 */
export const Initializer = ({ title = '', text = '', children }) => {
  return <Context.Provider value={{ title, text }}>{children}</Context.Provider>
}
